<template>
    <date-picker
        title-position="left"
        color="purple"
        v-model="date"
        @input="$emit('change', $event)"
        :max-date="new Date()"
        :mode="mode"
        is24hr
    >
        <template v-slot="{ inputValue, inputEvents }">
            <input
                :class="error ? 'error' : null"
                placeholder="jj/mm/aaaa"
                class="w-full focus:outline-none"
                :value="inputValue"
                v-on="inputEvents"
                @keydown="automaticSlash"
                @keyup="automaticSlash"
            />
        </template>
    </date-picker>
</template>

<script>
import { DatePicker } from "v-calendar";
import { onMounted, ref, watch } from "vue";

export default {
    name: "InputVCalendar",
    props: {
        mode: {
            default: "date",
        },
        label: {
            type: String,
            required: false,
        },
        modelValue: {
            type: Date,
        },
        error: {
            type: Boolean
        }
    },
    components: {
        DatePicker,
    },
    setup(props, { emit }) {
        const date = ref(null);

        onMounted(() => {
            if (props.modelValue) {
                date.value = props.modelValue;
            }
        });

        const clear = () => {
            date.value = null;
            emit("change", null);
        };

        const automaticSlash = (event) => {
            const inputLength = event.target.value.length;
            if (inputLength === 2 || inputLength === 5) {
                let thisVal = event.target.value;
                thisVal += "/";
                event.target.value = thisVal;
            }
        };

        watch(
            () => date.value,
            () => {
                emit("update:modelValue", date.value);
                emit("change", date.value);
            }
        );

        watch(
            () => props.modelValue,
            () => {
                if (props.modelValue) {
                    date.value = props.modelValue;
                }
            }
        );

        return { date, clear, automaticSlash };
    },
};
</script>

<style scoped>
.custom-date-picker {
    height: 55px;
}
</style>